import {
  getObject,
  getList,
} from "@surya-digital/leo-ts-types";
import { SurveyStatusAndName, SurveyStatusAndNameDTO } from "./surveyStatusAndName";
import { SurveyQuestionDetails, SurveyQuestionDetailsDTO } from "./surveyQuestionDetails";

export interface SurveyDetailsAndQuestionsDTO {
  surveyStatusAndName: SurveyStatusAndNameDTO;
  surveyQuestionDetails: SurveyQuestionDetailsDTO[];
}

export class SurveyDetailsAndQuestions {
  readonly isSurveyDetailsAndQuestionsSurveyDetailsAndQuestions: boolean = true;

  readonly surveyStatusAndName: SurveyStatusAndName;
  readonly surveyQuestionDetails: SurveyQuestionDetails[];


  constructor(
  surveyStatusAndName: SurveyStatusAndName, 
  surveyQuestionDetails: SurveyQuestionDetails[]
  ) {
    this.surveyStatusAndName = surveyStatusAndName;
    this.surveyQuestionDetails = surveyQuestionDetails;
  }

  static fromDTO(dto: SurveyDetailsAndQuestionsDTO): SurveyDetailsAndQuestions {
    const surveyStatusAndName = SurveyStatusAndName.fromDTO(getObject(dto, "surveyStatusAndName", InvalidSurveyDetailsAndQuestionsSurveyStatusAndNameError));
    const surveyQuestionDetails = getList<SurveyQuestionDetailsDTO, SurveyQuestionDetails>(
      dto,
      "surveyQuestionDetails",
      SurveyQuestionDetails.fromDTO,
      InvalidSurveyDetailsAndQuestionsSurveyQuestionDetailsError
    );
    return new SurveyDetailsAndQuestions(
      surveyStatusAndName,
      surveyQuestionDetails
    );
  }

  toDTO(): SurveyDetailsAndQuestionsDTO {
    const dto: SurveyDetailsAndQuestionsDTO = {
        surveyStatusAndName: this.surveyStatusAndName.toDTO(),
        surveyQuestionDetails: this.surveyQuestionDetails.map((e: SurveyQuestionDetails) => { return e.toDTO() })
    };
    return dto;
  }
  }

SurveyDetailsAndQuestions.prototype.toString = function toString(): string {
  return `SurveyDetailsAndQuestions(surveyStatusAndName='${this.surveyStatusAndName}',surveyQuestionDetails='${this.surveyQuestionDetails}')`;
};

export class InvalidSurveyDetailsAndQuestionsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyDetailsAndQuestionsError";
  }
}
export class InvalidSurveyDetailsAndQuestionsSurveyStatusAndNameError extends InvalidSurveyDetailsAndQuestionsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyDetailsAndQuestionsSurveyStatusAndNameError";
  }
}

export class InvalidSurveyDetailsAndQuestionsSurveyQuestionDetailsError extends InvalidSurveyDetailsAndQuestionsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyDetailsAndQuestionsSurveyQuestionDetailsError";
  }
}
